import { render } from "./skills-experience.vue?vue&type=template&id=2cfc5a11"
import script from "./skills-experience.vue?vue&type=script&lang=js"
export * from "./skills-experience.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__